import { Box, Card, Typography, useTheme } from '@mui/material';

interface ListLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  padding?: number;
}

export const ListLayout = ({ title, subtitle, children, padding = 3 }: ListLayoutProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" gap={3} flexDirection="column" p={theme.spacing(padding)}>
      <Box pl={2} display="flex" flexDirection="column" justifyContent="space-between" alignItems="flex-start">
        <Typography variant="h6" color={theme.palette.text.primary}>
          {title}
        </Typography>
        <Typography variant="subtitle1" align="left" color={theme.palette.text.disabled}>
          {subtitle}
        </Typography>
      </Box>

      <Card
        sx={{
          p: theme.spacing(3),
          boxShadow: 'none',
          borderRadius: theme.spacing(3),
        }}
        elevation={4}
      >
        {children}
      </Card>
    </Box>
  );
};
